import { Component, inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { EventService, Event } from '../../service/event.service';
import { tiers } from '../../service/account.service';
import { IconComponent } from "../../helper/icon/icon.component";

@Component({
  selector: 'app-events',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    RouterLink,
    IconComponent
],
  templateUrl: './events.component.html',
  styleUrl: './events.component.less'
})
export class EventsComponent implements OnInit {
  

  tiers = tiers;
  eventService = inject(EventService);
  events: Event[] = [];

  ngOnInit() {
    this.eventService.getEvents();
    this.eventService.$events.subscribe((events) => {
      this.events = events;
    });
  }

  getPatreonTierName(tier: number): string {
    return tiers[tier.toString()].name;
  }

  formatEventDate(date: Date): string {
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }

  isUpcoming(date: Date): boolean {
    const now = new Date();
    const twoDaysFromNow = new Date(now.getTime() + (8 * 24 * 60 * 60 * 1000));
    return date > now && date <= twoDaysFromNow;
  }
}
